const BlockComposition = {


  init() {
    this.fixToggableItems();
    $(window).on("resize", this.fixToggableItems.bind(this)); // Bind `this` to fixToggableItems
    this.events();
  },

  events() {
    $(".toggle-compositions").on("click", (e) => {
      const button = $(e.currentTarget);
      const items = $(".composition-item--toggleable");

      items.toggleClass("hidden");

      button.toggleClass("showing-more");

      if (button.hasClass("showing-more")) {
        button.text(button.attr("data-less"));

      } else {
        button.text(button.attr("data-more"));

      }
    });
  },

  fixToggableItems() {
    const mainItems = $(".composition-item");
    const moreItems = $(".composition-more .composition-item");
    const button = $(".toggle-compositions");
    let showingMore = button.hasClass("showing-more");


    //Code for Mobile screens

    if (window.innerWidth <= 600) {
      // Show btn
      if (mainItems.length > 3) {
        $(".toggle-compositions").removeClass("hidden");
      } else {
        $(".toggle-compositions").addClass("hidden");
      }

      mainItems.each((idx, item) => {
        if (idx > 2) {
          $(item).addClass("composition-item--toggleable");
        }
      })

      if (showingMore) {
        mainItems.each((idx, item) => {
          $(item).removeClass("hidden");
        });

        moreItems.each(item => {
          $(item).removeClass("hidden");
        })
      } else {

        mainItems.each((idx, item) => {
          if (idx > 2) {
            $(item).addClass("hidden");
          }
        })
      };

    } else

    ///Code for larger screens
    {
      // Show and hide btn
      if (moreItems.length > 0) {
        $(".toggle-compositions").removeClass("hidden");
      } else {
        $(".toggle-compositions").addClass("hidden");
      }

      mainItems.each((idx, item) => {
        $(item).removeClass("hidden");
        $(item).removeClass("composition-item--toggleable");
      });

      moreItems.each((idx, item) => {
        if (!showingMore) {
          $(item).addClass("hidden");
        }
        $(item).addClass("composition-item--toggleable");
      });
    }
  },
};

export default BlockComposition;
